import { LoginOutlined } from '@ant-design/icons';
import { useTranslation } from '@framework/i18n';
import { LinkButton, useCurrentMenuKey, useHistory } from '@framework/ui';
import { useLocation } from 'react-router';
import { down } from 'styled-breakpoints';
import { useBreakpoint } from 'styled-breakpoints/react-styled';
import styled from 'styled-components';
import { TopMenuIconButton } from '../../ui/menu/TopMenuIconButton';

const StyledLoginButton = styled(LinkButton)`
  &&& {
    &:focus-visible {
      outline: 2px solid ${props => props.theme.focusOutlineNegativeColor} !important;
      outline-offset: 0px !important;
      transition: all 0.2s;
    }
  }
`;

export interface LoginButtonProps {}
/**
 * Pulsante per andare alla pagina di login.
 */
export function LoginButton(props: LoginButtonProps) {
  const menuKey = useCurrentMenuKey();
  const location = useLocation();
  const { t } = useTranslation();
  const history = useHistory();
  const isMobile = useBreakpoint(down('md'));

  const handleClick = () => {
    history.push('/login', { from: location });
  };

  if (menuKey[0] === 'login') return null;

  if (isMobile) {
    return (
      <TopMenuIconButton
        aria-label={t('login-button.accedi', 'Accedi')}
        size="large"
        onClick={handleClick}
        icon={<LoginOutlined aria-hidden />}
      />
    );
  }

  return (
    <StyledLoginButton
      type="primary"
      to={{ pathname: '/login', state: { from: location } }}
      size="large"
    >
      {t('login-button.accedi', 'Accedi')}
    </StyledLoginButton>
  );
}
